import { useMemo, useState } from 'react';

const selectPrevIndex = (currentIndex: number, lastIndex: number) =>
  currentIndex === 0 ? lastIndex : currentIndex - 1;
const selectNextIndex = (currentIndex: number, lastIndex: number) =>
  currentIndex === lastIndex ? 0 : currentIndex + 1;

export const useCarousel = <T>(items: T[], initialIndex: number) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const lastIndex = items.length - 1;
  const prevIndex = useMemo(
    () => selectPrevIndex(currentIndex, lastIndex),
    [currentIndex, lastIndex]
  );
  const nextIndex = useMemo(
    () => selectNextIndex(currentIndex, lastIndex),
    [currentIndex, lastIndex]
  );

  const goTo = (index: number) => {
    setCurrentIndex(() => index);
  };

  const goToPrev = () => {
    setCurrentIndex((index) => selectPrevIndex(index, lastIndex));
  };
  const goToNext = () => {
    setCurrentIndex((index) => selectNextIndex(index, lastIndex));
  };

  return {
    currentIndex,
    prevIndex,
    nextIndex,
    goTo,
    goToPrev,
    goToNext,
  };
};
